import { useState } from "react";
import { toastr } from "react-redux-toastr";
import { useModal } from "../../../hooks/useModal";
import { TrafficSource } from "../../../services/TrafficSource";

export const useTrafficSourceTableLogic = ({
  filterValues,
  getTrafficSources,
  openEditForm
}) => {
  const [archiveModalOpen, openArchiveModal, closeArchiveModal] =
    useModal(false);
  const [archiveId, setArchiveId] = useState(null);

  const [deleteModalOpen, openDeleteModal, closeDeleteModal] = useModal(false);
  const [deleteId, setDeleteId] = useState(null);

  const [restoreModalOpen, openRestoreModal, closeRestoreModal] =
    useModal(false);
  const [restoreId, setRestoreId] = useState(null);

  function handleEditAction(id) {
    openEditForm(id);
  }

  function handleArchiveAction(id) {
    setArchiveId(id);
    openArchiveModal();
  }

  async function archiveTrafficSource() {
    try {
      const archivedTrafficSource = await TrafficSource.deleteTrafficSource(
        archiveId
      );
      if (archivedTrafficSource.success) {
        toastr.success("Success", "Traffic Type has been archived");
        getTrafficSources();
        handleModalClose();
      } else {
        throw new Error(JSON.stringify(archivedTrafficSource.error));
      }
    } catch (error) {
      console.trace(error.message);
      toastr.error("Oops!", "Not able to remove at the moment");
      handleModalClose();
    }
  }

  async function deleteTrafficSource() {
    try {
      const params = {
        permanent: true
      };
      const deletedTrafficSource = await TrafficSource.deleteTrafficSource(
        deleteId,
        params
      );
      if (deletedTrafficSource.success) {
        toastr.success("Traffic Type Deleted", "Traffic Type has been deleted");
        getTrafficSources();
        handleModalClose();
      } else {
        throw new Error(JSON.stringify(deletedTrafficSource.error));
      }
    } catch (error) {
      console.trace(error.message);
      toastr.error("Oops!", "Not able to remove at the moment");
      handleModalClose();
    }
  }

  async function restoreTrafficSource() {
    try {
      const params = {
        archive: false
      };
      const dataToSend = {};
      const restoredTrafficSource = await TrafficSource.updateTrafficSource(
        restoreId,
        dataToSend,
        params
      );
      if (restoredTrafficSource.success) {
        toastr.success("Success", "Traffic Type restored successfully");
        getTrafficSources();
        handleModalClose();
      } else {
        throw new Error(restoredTrafficSource.error);
      }
    } catch (error) {
      console.trace(error.message);
      toastr.error("Oops", "Not able to restore traffic type");
      handleModalClose();
    }
  }

  function handlePermanaentDeleteAction(id) {
    setDeleteId(id);
    openDeleteModal();
  }

  function handleRestoreAction(id) {
    setRestoreId(id);
    openRestoreModal();
  }

  const handleModalClose = () => {
    closeArchiveModal();
    closeDeleteModal();
    closeRestoreModal();
    setArchiveId(null);
    setDeleteId(null);
    setRestoreId(null);
  };

  const headers = [
    { title: "ID", value: "id" },
    { title: "Name", value: "name" },
    { title: "Details", value: "details" }
  ];

  let actions = [];
  if (!filterValues.archivedData) {
    actions = [
      {
        name: "edit",
        action: handleEditAction,
        icon: "editIcon"
      }
      // {
      //   name: "delete",
      //   action: handleArchiveAction,
      //   icon: "deleteIcon"
      // }
    ];
  } else {
    actions = [
      {
        name: "deleteForever",
        action: handlePermanaentDeleteAction,
        icon: "deleteForever"
      },
      {
        name: "restore",
        action: handleRestoreAction,
        icon: "restore"
      }
    ];
  }

  return {
    headers,
    actions,
    archiveModalOpen,
    deleteModalOpen,
    restoreModalOpen,
    handleModalClose,
    archiveTrafficSource,
    deleteTrafficSource,
    restoreTrafficSource,
    handleArchiveAction
  };
};
